import React, {useState, useRef, useEffect } from 'react';
import { compose, toUpper } from 'ramda';
import styleFile from './header.js';
import { RichText, Button } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';


const LangSelector = compose(withThemeJSS({ styleFile, displayName: 'Header' }))((props) => {
  const { classes } = props.theme.styles;
  let { langActive } = props;
  const { countryCode } = props;

  if (langActive === 'de') langActive = 'AL'; // xd

  const langs = window.CMSElementLangURLs ? window.CMSElementLangURLs : [];

  if (!langs.length) {
    return null;
  }

  let currentLang;
  const langList = langs.filter((lang) => {
    if (lang.code === toUpper(langActive)) {
      currentLang = lang;
    }
    if (countryCode === 'US' && lang.code === 'EN'){
      lang.url = lang.url.replace('.co.uk','.us')
    }
    return lang.code !== toUpper(langActive);
  });

  const [collapsedSelector, setCollapsedSelector] = useState(true);
  const selectorRef = useRef(null);

  useEffect(() => {
    function handleEventsOutside(event) {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setCollapsedSelector(true);
      }
    }

    document.addEventListener('pointerdown', handleEventsOutside);
    document.addEventListener('scroll', handleEventsOutside, true);
    return () => {
      document.removeEventListener('pointerdown', handleEventsOutside);
      document.removeEventListener('scroll', handleEventsOutside, true);
    };
  }, []);

  return (
    <div className={classes.langSelectorContainer} ref={selectorRef}>
      <Button
        onClick={() => setCollapsedSelector(!collapsedSelector)}
        innerStyle={[classes.langSelectorBtn, collapsedSelector ? classes.up : classes.down]}
        rightIcon={{
          svg: 'dropDownArrow',
          innerStyle: [classes.langSelectorIcon, collapsedSelector ? classes.up : classes.down]
        }}>
        <RichText
          innerStyle={classes.langSelected}
          text={props.theme.width > 1280 ? currentLang.name : currentLang.code}
          ucFirst={true}
        />
      </Button>
      {!collapsedSelector && (
        <ul className={classes.langSelectWrapper}>
          {langList.map((lang) => (
            <li key={lang.code}>
              <a href={`${lang.url}${window.location.search}`}>{props.theme.width > 1280 ? lang.name : lang.code}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

export default LangSelector;